export default "__VITE_ASSET__D$n8w2vB__"